export const FEEDBACK_SECTIONS: Record<string, string[]> = {
  programming: ['Communication', 'Tech Skills', 'Pros', 'Cons'],
  non_programming: ['Communication', 'Domain Knowledge', 'Pros', 'Cons'],
  business: ['Communication', 'Business Acumen', 'Pros', 'Cons'],
  default: ['Communication', 'Skills', 'Pros', 'Cons'],
};

export function getFeedbackTemplate(jobType?: string): string {
  const sections = FEEDBACK_SECTIONS[jobType ?? ''] || FEEDBACK_SECTIONS.default;
  return sections.map((s) => `- ${s}:`).join('\n');
}
